import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListOcpiSessionIdCell } from '@app/feature/transaction/transaction-list/transaction-list-ocpi-session-id.cell';
import { TransactionListOcpiSessionIdHeader } from '@app/feature/transaction/transaction-list/transaction-list-ocpi-session-id.header';

export const TokenTransactionListOcpiSessionIdColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['ocpiSessionId']
> = {
  enableSorting: false,
  header: TransactionListOcpiSessionIdHeader,
  cell: TransactionListOcpiSessionIdCell,
};
